import StateProvider, { useContextState } from './StateProvider';

export { useContextState };
export default StateProvider;
